<mat-form-field class="flex">
  <mat-label>{{config.label}}</mat-label>
  <input type="text" *ngIf="required" required matInput [formControl]="myControl" [matAutocomplete]="auto">
  <input type="text" *ngIf="!required" matInput [formControl]="myControl" [matAutocomplete]="auto">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option (click)="optionSelected(option)" *ngFor="let option of filteredOptions | async" [value]="option">
      {{option.name}}
    </mat-option>
  </mat-autocomplete>
  <mat-icon (click)="clear()" *ngIf=" myControl.value && myControl.value.id && !disabled" matSuffix>clear
  </mat-icon>
</mat-form-field>
